const state = {
    authorized: false, // 是否已授权
    navTags: [], // 标签导航列表
    cachedViews: [], // 缓存的页面
    collapse: false // 左侧导航是否收缩
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js